export default "__VITE_ASSET__DGpAjROE__"